// src/components/ProtectedRoute.tsx  (Clerk-alapú)
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useUser } from "@clerk/clerk-react";

const ProtectedRoute: React.FC = () => {
    const { isLoaded, isSignedIn } = useUser();
    const location = useLocation();

    if (!isLoaded) {
        return (
            <Box sx={{ width: "100vw", minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <CircularProgress />
            </Box>
        );
    }

    if (!isSignedIn) {
        return <Navigate to="/authpages" state={{ isLogin: true, from: location }} replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;